// import $ from 'jquery';

// document.addEventListener("DOMContentLoaded", function () {
//   const priceIndexBlock = document.getElementsByClassName("price-index-block")[0];
//   if (priceIndexBlock) {
//     const filterForm = document.getElementById("filter-form");
//     const filterForm2 = document.getElementById("filter-form2");
//     const filterForm3 = document.getElementById("filter-form3");

//     const filterForm4 = document.getElementById("gold-history-form");
//     const filterForm5 = document.getElementById("silver-history-form");

//     const materialFilter = filterForm.querySelector(".material");
//     const currencyFilter1 = filterForm2.querySelector(".currency");
//     const currencyFilter2 = filterForm3.querySelector(".currency");

//     const historyFilter1 = filterForm4.querySelector(".history");
//     const historyFilter2 = filterForm5.querySelector(".history");

//     const firstCurrencyWrappers = document.querySelectorAll(".first-currency");

//     const graphWrappers = document.querySelectorAll(".graph-wrapper");
//     const currencyWrappers = document.querySelectorAll(".currency-wrapper");

//     const historyWrappers = document.querySelectorAll(".history-wrapper");

//     filterForm.addEventListener("change", function () {
//       const selectedMaterial = materialFilter.querySelector(
//         'input[name="material"]:checked'
//       ).value;

//       graphWrappers.forEach(function (graphWrapper) {
//         const material = graphWrapper.id; // Get material from the ID (gold or silver)

//         if (material === selectedMaterial) {
//           graphWrapper.style.display = "block";
//         } else {
//           graphWrapper.style.display = "none";
//         }
//       });

//       historyWrappers.forEach(function (historyWrapper) {
//         historyWrapper.style.display = "none";
//       });

//       firstCurrencyWrappers.forEach(function (firstCurrencyWrapper) {
//         firstCurrencyWrapper.style.display = "block";
//       });
//     });

//     filterForm2.addEventListener("change", function () {
//       let selectedCurrency = currencyFilter1.querySelector(
//         'input[name="currency"]:checked'
//       ).value;

//       console.log(selectedCurrency);

//       currencyWrappers.forEach(function (currencyWrapper) {
//         let currency = currencyWrapper.id; // Get currency from the ID (gbp, usd, eur)
//         if (currency === selectedCurrency) {
//           currencyWrapper.style.display = "block";
//         } else {
//           currencyWrapper.style.display = "none";
//         }
//       });
//     });

//     filterForm3.addEventListener("change", function () {
//       let selectedCurrency1 = currencyFilter2.querySelector(
//         'input[name="currency"]:checked'
//       ).value;

//       console.log(selectedCurrency1);

//       currencyWrappers.forEach(function (currencyWrapper) {
//         let currency = currencyWrapper.id; // Get currency from the ID (gbp, usd, eur)
//         if (currency === selectedCurrency1) {
//           currencyWrapper.style.display = "block";
//         } else {
//           currencyWrapper.style.display = "none";
//         }
//       });
//     });

//     filterForm4.addEventListener("change", function () {
//       let selectedHistory1 = historyFilter1.querySelector(
//         'input[name="history"]:checked'
//       ).value;

//       historyWrappers.forEach(function (historyWrapper) {
//         let history = historyWrapper.id; // Get currency from the ID (gbp, usd, eur)
//         if (history === selectedHistory1) {
//           historyWrapper.style.display = "block";
//         } else {
//           historyWrapper.style.display = "none";
//         }
//       });
//     });

//     filterForm5.addEventListener("change", function () {
//       let selectedHistory2 = historyFilter2.querySelector(
//         'input[name="history"]:checked'
//       ).value;

//       historyWrappers.forEach(function (historyWrapper) {
//         let history = historyWrapper.id; // Get currency from the ID (gbp, usd, eur)
//         if (history === selectedHistory2) {
//           historyWrapper.style.display = "block";
//         } else {
//           historyWrapper.style.display = "none";
//         }
//       });
//     });
//   }
// });
